import { t } from "i18next";

import TitledPage from "@/modules/common/components/layout/pages/TitledPage";

const UsersPage = () => {
  return <TitledPage title={t("Admin Users")}></TitledPage>;
};

export default UsersPage;
